import React from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
  faCalendarCircleUser,
  faIdCard,
  faUser,
  faKitMedical,
  faHandHoldingDollar,
  faBriefcase,
} from '@fortawesome/pro-light-svg-icons';
import { Beneficiaries } from './utils/beneficiaryInterfaces';
import Selector from 'shared/design-system/components/Selector';

export const getBeneficiaryIcon = (
  category: BeneficiaryMainCardProps['category'],
): BeneficiaryMainCardProps['icon'] => {
  switch (category) {
    case 'age':
      return faCalendarCircleUser;
    case 'ethnic':
      return faIdCard;
    case 'gender':
      return faUser;
    case 'health':
      return faKitMedical;
    case 'social':
      return faHandHoldingDollar;
    case 'work':
      return faBriefcase;
  }
};

export interface BeneficiaryMainCardProps {
  tooltipComponent: JSX.Element;
  icon: FontAwesomeIconProps['icon'];
  text: string;
  category: keyof Beneficiaries;
  selected: boolean;
  onClick: (category: keyof Beneficiaries) => unknown;
}

type MainCardProps = Omit<
  BeneficiaryMainCardProps,
  'onClick' | 'category' | 'tooltipComponent'
> & {
  id?: string;
  className?: string;
  onClick: () => unknown;
  tooltipComponent?: BeneficiaryMainCardProps['tooltipComponent'];
};

export const MainCard: React.FC<MainCardProps> = ({
  id,
  onClick,
  selected,
  icon,
  tooltipComponent,
  text,
  className,
}) => {
  return (
    <Selector
      id={id}
      onClick={onClick}
      selected={selected}
      label={text}
      variant="primary-checkbox"
      icon={icon}
      tooltipComponent={tooltipComponent}
      animationScale={1.3}
      className={className}
    />
  );
};

const BeneficiaryMainCard: React.FC<BeneficiaryMainCardProps> = ({
  icon,
  text,
  category,
  selected,
  tooltipComponent,
  onClick,
}) => {
  const handleClick = () => onClick(category);
  return (
    <MainCard
      icon={icon}
      text={text}
      onClick={handleClick}
      selected={selected}
      tooltipComponent={tooltipComponent}
    />
  );
};

export default BeneficiaryMainCard;
